export const SET_DEPOSITS_WITHOUT_TRAVEL_RULE_DATA_LOADING = "SET_DEPOSITS_WITHOUT_TRAVEL_RULE_DATA_LOADING";
export const SET_DEPOSITS_WITHOUT_TRAVEL_RULE_DATA = "SET_DEPOSITS_WITHOUT_TRAVEL_RULE_DATA";
export const FETCH_DEPOSITS_WITHOUT_TRAVEL_RULE_DATA = "FETCH_DEPOSITS_WITHOUT_TRAVEL_RULE_DATA";
